export interface PaymentResponse {
    Header: PaymentHeader;
    ResponseHeader: PaymentResponseHeader;
}

export interface PaymentHeader {
    OrderNumber: string;
    TimeStamp: string;
}

export interface PaymentResponseHeader {
    ProductResponse: PaymentProductResponse[];
}

export interface PaymentProductResponse {
    Type: PaymentResponseType;
    Code: string;
    Message: string;
    SubType: PaymentSubType | null;
    DenialReason: string | null;
    AutopayAmount: number;
    AuthCode: string | null;
    AutopayCardType: string | null;
    FdeActionRequired: string | null;
    FdeCode: string | null;
    FdeMessage: string | null;
    IsAutopayDebitCard: string | null;
    CardType?: string | null; // Added for VI Payment Card Type
}

export interface AutopayDetails {
    amount: number;
    cardType: string;
    isDebitCard: boolean;
    authCode: string;
}

export interface PaymentCardTypeResponse {
    ResponseHeader: PaymentResponseHeader
}

export enum PaymentResponseType {
    OVERALL = 'OVERALL',
    RC1 = 'RC1',
    ATT = 'ATT',
    WIRELESS = 'WIRELESS',
    VIDEO = 'VIDEO'
}

export enum PaymentSubType {
    PAYMENT = 'Payment'
}